import { ServiceSettingsChatSpecialist } from '@/service/specialists/serviceSettingsChatSpecialist'

const serviceSettingsChatSpecialist = new ServiceSettingsChatSpecialist()
export default {
  namespaced: true,
  state: {
    loadingSettingsChat: false,

  },
  getters: {},
  mutations: {},
  actions: {
    async getSettingsChat({ commit }) {
      try {
        const response = await serviceSettingsChatSpecialist.getSettingsChat()
        return response
      } catch (error) {
        console.log(error)
      }
    },
    async updateSettingsChat(ctx, { query, payload }) {
      return new Promise((resolve, reject) => {
        serviceSettingsChatSpecialist.updateSettingsChat(query, payload)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    async createSettingsChat(ctx, data) {
      return new Promise((resolve, reject) => {
        serviceSettingsChatSpecialist.createSettingsChat(data)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },

}
